import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "31",
  fill: "none",
  viewBox: "0 0 27 31"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m11.751 16.55-2.333-2.1A1.7 1.7 0 0 0 8.251 14q-.666 0-1.166.45t-.5 1.068q0 .62.5 1.07l3.5 3.187q.5.45 1.166.45.667 0 1.167-.45l7.083-6.375q.5-.45.5-1.07 0-.618-.5-1.068t-1.187-.45-1.188.45zm1.75 13.8a4 4 0 0 1-.541-.038 4 4 0 0 1-.5-.112Q6.835 28.512 3.5 23.956.168 19.399.168 14.15V7.062q0-.937.604-1.687t1.563-1.088l10-3.375A3.8 3.8 0 0 1 13.5.725q.584 0 1.167.187l10 3.375q.959.338 1.563 1.088t.604 1.687v7.088q0 5.25-3.334 9.806T14.543 30.2q-.25.075-.5.112a4 4 0 0 1-.542.038m0-3q4.334-1.238 7.167-4.95t2.833-8.25V7.062l-10-3.375-10 3.375v7.088q0 4.537 2.834 8.25t7.166 4.95"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }